/** @jsxImportSource @emotion/react */
import React from 'react'
import { jsx, css } from '@emotion/react'
import { Link } from 'react-router-dom'
import CommonTable from '../../components/CommonTable'
import Timestamp from '../../components/Timestamp'
import { InlineIcon } from '../../components/layout/InlineIcon'
import { LanguageFlag } from '../../components/LanguageFlag'
import { ButtonBar } from '../../components/layout/ButtonBar'

/* The editable email table is shared by the catalogue page (AdminEditableEmails) and the
   manual emails page (AdminManualEditableEmails). Only the list that feeds it differs.

   The row actions are opt-in via props: the catalogue page passes none of them, since those
   emails are defined by the codebase and are managed through migrations rather than edited
   freely. onRun and onShowRuns are only meaningful for manual emails. */

export const EDITABLE_EMAIL_HEADERS = {
    name: { name: 'Name', column_size: 1 },
    language_code: { name: 'Language', column_size: 1 },
    description: { name: 'Description', column_size: 1 },
    modified_at: { name: 'Modified', column_size: 1 },
    published: { name: 'Ready', column_size: 1 },
    action: { name: '', column_size: 1 },
}

function renderCell(header_key, item, column_size, row_index, index, current_state, editable) {
    switch( header_key ) {
        case 'description':
            return (
                <div css={description_style}>
                  {item.description}
                </div>
            )
        default:
            return undefined;
    }
}

export const EditableEmailsTable = ({ item_list, items, is_loading, empty_message, onDelete, onRun, onShowRuns }) => {

    const getCellValue = (header_key, item, index) => {
        switch( header_key ) {
            case 'name':
                return (
                    <div>
                      {item.name}
                    </div>
                )
            case 'language_code':
                return <LanguageFlag language_code={item.language_code} />
            case 'modified_at':
                return (
                    <Timestamp value={item.modified_at} format='datetime' />
                )
            case 'published':
                return (
                    <div>
                      { item.published === true && <InlineIcon icon_name='status-success' /> }
                      { item.published !== true && <InlineIcon icon_name='status-error' /> }
                    </div>
                )
            case 'action':
                return (
                    <ButtonBar>
                      <Link to={`/admin/editable_email/${item.id}`}>
                        <InlineIcon icon_name="edit" />
                      </Link>
                      { onRun && <InlineIcon icon_name="play" onClick={(evt) => onRun(item)} /> }
                      { onShowRuns && <InlineIcon icon_name="list" onClick={(evt) => onShowRuns(item)} /> }
                      { onDelete && <InlineIcon icon_name="delete" onClick={(evt) => onDelete(item)} /> }
                    </ButtonBar>
                )
            default:
                return undefined
        }
    }

    return (
        <CommonTable
            is_loading={ is_loading }
            empty_message={ empty_message }
            headers={ EDITABLE_EMAIL_HEADERS }
            items={ items }
            item_list={ item_list }
            renderCell={ renderCell }
            getCellValue={ getCellValue }
        />
    )
}

export default EditableEmailsTable

const description_style = css`
font-size: 14px;
overflow: hidden;
max-width: 500px;
text-overflow: ellipsis;
`
